var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.root},_vm._l((_vm.options),function({ text, value }){return _c('VCheckbox',{key:value,staticClass:"mt-0",attrs:{"disabled":_vm.readonly || (_vm.only && value !== _vm.only),"label":text,"value":value,"hide-details":""},model:{value:(_vm.values),callback:function ($$v) {_vm.values=$$v},expression:"values"}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }